import dynamic from 'next/dynamic';
import { Fragment } from 'react';
import { NextSeo } from 'next-seo';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Skelet from '../components/Skelet';
import styles from '../styles/modules/favorites/Favorites.module.scss';

const FavoritesStatistic = dynamic(() => import('../components/favorites/FavoritesStatistic'), {
  loading: () => (
    <section className="block">
      <div className="fixed">
        <div className={styles.statistics}>
          <Skelet height={120} width={120} className={styles.statisticsGraph} />
          <Skelet height={120} className={styles.statisticsContent} />
        </div>
      </div>
    </section>
  )
});
const FavoritesList = dynamic(() => import('../components/favorites/FavoritesList'), {
  loading: () => (
    <section className="block">
      <div className="fixed">
        <div className={styles.list}>
          <div className={styles.listHeader}>
            <Skelet height={33} maxWidth={200} className={styles.listHeaderTitle} />
          </div>
          <div className={styles.listContent}>
            {[...Array(3).keys()].map((value) => (
              <div className={styles.listItem} key={value}>
                <div className={styles.listItemGallery}>
                  <div className={styles.listItemGalleryPhoto}>
                    <Skelet style={{ position: 'absolute', height: '100%', borderRadius: 20 }} />
                  </div>
                </div>
                <div className={styles.listItemData}>
                  <Skelet className={styles.listItemPrice} height={33} maxWidth={200} />
                  <Skelet className={styles.listItemAddress} height={21} maxWidth={240} />
                  <div className={styles.listItemProperties}>
                    <Skelet
                      className={styles.listItemProperty}
                      width={60}
                      height={32}
                      style={{ marginRight: 12 }}
                    />
                    <Skelet
                      className={styles.listItemProperty}
                      width={60}
                      height={32}
                      style={{ marginRight: 12 }}
                    />
                    <Skelet
                      className={styles.listItemProperty}
                      width={60}
                      height={32}
                      style={{ marginRight: 12 }}
                    />
                  </div>
                  <Skelet className={styles.listItemDescription} height={110} />
                  <div className={styles.listItemActions}>
                    <div className={styles.listItemDate} />
                    <Skelet width={150} height={44} style={{ borderRadius: 18 }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
});

const FavoritesPage = () => {
  return (
    <Fragment>
      <NextSeo
        noindex
        nofollow
        title="Моё избранное в агентстве недвижимости «ЛЕНДЛОРД»"
        description="Мои избранные в агентстве недвижимости «ЛЕНДЛОРД» в Ростовской области: объекты, избранное."
        openGraph={{
          url: 'https://landlord.ru',
          type: 'website',
          title: 'Моё избранное в агентстве недвижимости «ЛЕНДЛОРД»',
          description:
            'Мои избранные в агентстве недвижимости «ЛЕНДЛОРД» в Ростовской области: объекты, избранное.',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <FavoritesStatistic />
        <FavoritesList />
      </main>
      <Footer />
    </Fragment>
  );
};

export default FavoritesPage;
